import React from 'react';
import { LuCheckCircle2, LuCircle } from 'react-icons/lu';
import { BsFillCheckCircleFill } from "react-icons/bs";


export default function Component(props) {

  const { question, answersList, surveyLanguageCode, handleRadio, clicked, surveyScreenData } = props;

  return (
    <>

      {question && question.optionsList && question.optionsList.length > 0 ?
        question.optionsList.map((option, optionindex) => (
          <div
            key={option.id}
            onClick={() => handleRadio(optionindex, question, option)}
            className={`group flex items-center gap-4 px-3 py-2 bg-white rounded-xl border-2 cursor-pointer transition-all duration-200 ${(answersList.some(item => option.id === item.questionOptionId)) || (clicked === option.id)
              ? 'border-gray-300'
              : 'border-gray-300 hover:border-gray-300'
              }`}
          >
            <div className="mt-1 flex-shrink-0">
              {(answersList.some(item => option.id === item.questionOptionId)) || (clicked === option.id) ? (
                <BsFillCheckCircleFill className="text-indigo-600" size={36} />
              ) : (
                <LuCircle className="text-indigo-600" size={36} />
              )}
            </div>
            <p className="text-sm md:text-base leading-snug textblack">
              {(surveyLanguageCode !== '') ?
                (question && question.transl && question.transl[surveyLanguageCode] && question.transl[surveyLanguageCode].optionsList && question.transl[surveyLanguageCode].optionsList[option.id]) ?
                  question.transl[surveyLanguageCode].optionsList[option.id] : option.name

                : option.name}
            </p>
          </div>
        )) : null}

    </>
  );
}